export interface SetPasswordState {
  isLoading: boolean
  currentStep: 'ESTABLISH_PASSWORD' | 'PASSWORD_SUCCESSFUL'
  email: string | null
  token: string | null
}

export type RecoveryStep = SetPasswordState['currentStep']

export const initialState: SetPasswordState = {
  currentStep: 'ESTABLISH_PASSWORD',
  isLoading: false,
  email: null,
  token: null
}
